module.exports = __webpack_public_path__ + "img/SES_4038069720.df93fab8.jpg";